import React from "react";

const cars = [
  { name: "Swift Dzire", img: "/images/Fleet/Dzire.jpg", seats: "4 Seater", luggage: "2 Bags", type: "Sedan" },
  { name: "Maruti Ertiga", img: "/images/Fleet/ertiga.jpg", seats: "6 Seater", luggage: "3 Bags", type: "SUV" },
  { name: "Toyota Rumion", img: "/images/Fleet/rumion.jpg", seats: "6 Seater", luggage: "3 Bags", type: "MUV" },
  { name: "Kia Carens", img: "/images/Fleet/kia.jpg", seats: "6/7 Seater", luggage: "3 Bags", type: "Luxury MUV" },
  { name: "Innova Cab", img: "/images/Fleet/innova.jpg", seats: "7 Seater", luggage: "4 Bags", type: "SUV" },
  { name: "Innova Crysta", img: "/images/Fleet/innova-crysta.jpg", seats: "7 Seater", luggage: "4 Bags", type: "Premium SUV" },
  { name: "Tempo Traveller", img: "/images/Fleet/tempo-traveller.jpg", seats: "12 Seater", luggage: "8 Bags", type: "Traveller" },
  { name: "Urbania Bus", img: "/images/Fleet/urbania.jpg", seats: "17 Seater", luggage: "10 Bags", type: "Luxury Bus" },
  { name: "Mini Bus", img: "/images/Fleet/mini-bus.jpg", seats: "20+ Seater", luggage: "12 Bags", type: "Bus" },
];

const Booking = () => {

  const handleWhatsApp = (carName) => {
    const phoneNumber = "919529877342";

    const message = `Hello, I want to book ${carName} from Royal Route Cab. Please share details.`;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
  };

  return (
    <>
    
 <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">Booking</h1>
          </div>
        </div>
      </div>


    <section className="booking-section">
      <div className="container">

        {/* <div className="booking-header text-center">
          <h2>Our Fleet <span>Royal Route Cab</span></h2>
          <p>Select the perfect ride for your journey</p>
        </div> */}

        <div className="row">
          {cars.map((car, index) => (
            <div className="col-md-4 col-sm-6 mb-4" key={index}>
              
              <div className="booking-card">
                
                <div className="booking-img">
                  <img src={car.img} alt={car.name} />
                </div>

                <div className="booking-content">
                  <h4>{car.name}</h4>

                  <div className="specs">
                    <span>👤 {car.seats}</span>
                    <span>🧳 {car.luggage}</span>
                    <span>🚘 {car.type}</span>
                  </div>

                  <button 
                    className="book-btn"
                    onClick={() => handleWhatsApp(car.name)}
                  >
                    Book Now
                  </button>
                </div>

              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
    
    </>
  );
};

export default Booking;